import { NumericCountdown } from '@liveauctioneers/hammer-ui-core/countdown/numeric';
import { H6, LabelMini } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { ReactNode, useState } from 'react';

type Props = {
    completionTime?: number;
    hideCountdown?: boolean;
    isMobile?: boolean;
    label: ReactNode;
    onComplete?: () => void;
};

export const CountdownBadge = ({
    completionTime,
    hideCountdown = false,
    isMobile = false,
    label,
    onComplete,
}: Props) => {
    const [isComplete, setIsComplete] = useState(
        () => !hideCountdown && Boolean(completionTime) && completionTime <= Date.now()
    );

    if (isComplete) {
        return null;
    }

    return (
        <div
            className={cn(
                'absolute bottom-2xs left-2xs flex flex-row items-center gap-xs rounded-md border border-border-secondary bg-surface-50/50 px-xs py-2xs backdrop-blur-[8px]',
                'smMin:bottom-0 smMin:left-0 smMin:flex-col smMin:items-stretch smMin:gap-2xs smMin:overflow-hidden smMin:rounded-tl-none smMin:rounded-br-none smMin:border-0 smMin:py-0 smMin:pt-xs smMin:pb-2xs'
            )}
        >
            {isMobile ? <H6 className="tracking-widest uppercase">{label}</H6> : <LabelMini>{label}</LabelMini>}
            {!hideCountdown && completionTime !== undefined && (
                <NumericCountdown
                    completionTime={completionTime}
                    forceUrgent
                    className={isMobile ? '!hui-text-h6' : ''}
                    onComplete={() => {
                        setIsComplete(true);
                        onComplete?.();
                    }}
                />
            )}
        </div>
    );
};
